import { render, staticRenderFns } from "./JdsTerminology.vue?vue&type=template&id=6f3f27e4&scoped=true&"
import script from "./JdsTerminology.vue?vue&type=script&lang=ts&"
export * from "./JdsTerminology.vue?vue&type=script&lang=ts&"
import style0 from "./JdsTerminology.vue?vue&type=style&index=0&id=6f3f27e4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f3f27e4",
  null
  
)

export default component.exports